// extracted by mini-css-extract-plugin
export default {"box":"GeneralPoints_box__VbJfc","points":"GeneralPoints_points__FhGXT"};